/* MI CASA LUNA — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (un solo observer) ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mcl-reveal:not(.mcl-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mcl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mcl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Formato de precio con el formato de la tienda ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '{{amount_with_comma_separator}} €';
    function withDelims(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = withDelims(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, '.', ',');
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Página de producto: galería + variantes + cantidad ---------- */
  function initProducto() {
    document.querySelectorAll('[data-mcl-producto]').forEach(function (root) {
      // Galería
      // Ojo: image_tag de Shopify elimina atributos data-*, por eso se localiza por la clase del contenedor
      var principal = root.querySelector('[data-mcl-principal]') || root.querySelector('.mcl-galeria__principal img');
      var minis = root.querySelectorAll('[data-mcl-mini]');
      var clip = root.querySelector('[data-mcl-clip]');
      var miniVideo = root.querySelector('[data-mcl-mini-video]');
      function verClip(ver) {
        if (!clip) return;
        clip.classList.toggle('is-oculto', !ver);
        if (miniVideo) miniVideo.classList.toggle('is-activa', ver);
        var v = clip.querySelector('video');
        if (!v) return;
        if (!ver) { v.pause(); return; }
        if (!v.getAttribute('src')) v.src = v.getAttribute('data-mcl-video-src');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      if (miniVideo) miniVideo.addEventListener('click', function () {
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        verClip(true);
      });
      function mostrar(btn) {
        if (!principal || !btn) return;
        verClip(false);
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = btn.getAttribute('data-src');
          principal.srcset = btn.getAttribute('data-srcset') || '';
          principal.alt = btn.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 160);
        minis.forEach(function (m) { m.classList.toggle('is-activa', m === btn); });
      }
      minis.forEach(function (btn) { btn.addEventListener('click', function () { mostrar(btn); }); });

      // Cantidad
      var qty = root.querySelector('[data-mcl-cantidad]');
      root.querySelectorAll('[data-mcl-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-mcl-qty'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var dataEl = root.querySelector('[data-mcl-variantes]');
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var moneyFormat = root.getAttribute('data-money-format');
      var idInput = root.querySelector('[data-mcl-variant-id]');
      var precioEl = root.querySelector('[data-mcl-precio]');
      var boton = root.querySelector('[data-mcl-boton]');
      var textoBoton = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';

      function actualizar() {
        var seleccion = [];
        root.querySelectorAll('[data-mcl-opcion]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          seleccion.push(checked ? checked.value : null);
        });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === seleccion[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = 'No disponible'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precioEl) {
          var html = '<span class="mcl-precio__actual">' + formatMoney(v.price, moneyFormat) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html += '<s>' + formatMoney(v.compare_at_price, moneyFormat) + '</s>';
            precioEl.classList.add('mcl-precio--oferta');
          } else {
            precioEl.classList.remove('mcl-precio--oferta');
          }
          precioEl.innerHTML = html;
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.featured_media && principal) {
          var mini = root.querySelector('[data-mcl-mini][data-media-id="' + v.featured_media.id + '"]');
          if (mini) mostrar(mini);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('[data-mcl-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
    });
  }

  /* ---------- Vídeo de producto: carga diferida + botón de pausa ---------- */
  function initVideos(root) {
    (root || document).querySelectorAll('[data-mcl-video-src]').forEach(function (video) {
      if (video.dataset.mclListo) return;
      video.dataset.mclListo = '1';
      var boton = video.parentNode.querySelector('[data-mcl-video-boton]');
      var pausadoPorUsuario = reduceMotion;
      function reproducir() { if (!pausadoPorUsuario) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } }
      function cargar() {
        if (!video.getAttribute('src')) { video.src = video.getAttribute('data-mcl-video-src'); }
        reproducir();
      }
      function pintarBoton() {
        if (!boton) return;
        var pausado = video.paused;
        boton.setAttribute('aria-pressed', pausado ? 'true' : 'false');
        boton.setAttribute('aria-label', pausado ? 'Reproducir vídeo' : 'Pausar vídeo');
        boton.classList.toggle('is-pausado', pausado);
      }
      video.addEventListener('play', pintarBoton);
      video.addEventListener('pause', pintarBoton);
      if (boton) {
        boton.addEventListener('click', function () {
          if (!video.getAttribute('src')) { pausadoPorUsuario = false; cargar(); return; }
          if (video.paused) { pausadoPorUsuario = false; reproducir(); } else { pausadoPorUsuario = true; video.pause(); }
        });
      }
      pintarBoton();
      if (!('IntersectionObserver' in window)) { cargar(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { cargar(); } else if (video.getAttribute('src') && !video.paused) { video.pause(); }
        });
      }, { rootMargin: '200px 0px' }).observe(video);
    });
  }

  function init() {
    initReveals();
    initProducto();
    initVideos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de Shopify: re-inicializar al cargar una sección
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); initProducto(); initVideos(e.target); });
})();
